<!--<div class="loading-backdrop" id="full-backdrop" style="opacity: 0.8; background-color: rgb(255, 255, 255);">-->
<div style="z-index: 1300; position: relative;" *ngIf="loading2"> 
    <div class="loading-backdrop" id="full-backdrop">
        <div class="loading-comp">
          <mat-progress-spinner [diameter]="140" mode="indeterminate"></mat-progress-spinner>
        </div>
    </div>
</div>